import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";

/**
 *
 * @param programIdentifier program identifier
 * @param options useMutation options
 * @returns useMutation result
 */
export const useRequestDiaryReport = (
  programIdentifier: string,
  options?: UseMutationOptions<void, PortalAxiosError, void>
) => {
  const server = useServer();

  return useMutation<void, PortalAxiosError, void>(
    () => server.post(`programs/${programIdentifier}/reports/send`),
    options
  );
};

export default useRequestDiaryReport;
